import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[fbTemplate]',
})
export class TemplateDirective<T> {
  @Input()
  set fbTemplateOf(name: string) {
    this.name = name;
  }
  name: string;

  constructor(public templateRef: TemplateRef<T>) {}
}
